import { VFC } from "react";

import { Warning } from "src/components/warning";

const NotFoundPage: VFC = () => {
  return <Warning fullScreen subtitle="Sorry, we could not find what you were looking for!" title="Not found" />;
};

export default NotFoundPage;
